import FoodBankOutlinedIcon from "@mui/icons-material/FoodBankOutlined";
import { Box, Grid } from "@mui/material";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import { Gig } from "../../interfaces/Gig";
import { theme } from "../../mui-customs/Theme";
import { RootState } from "../../redux/store";
import GigCard from "../GigCard";
import NoDataUI from "../NoDataUI";
import Typography from "../Typography";

interface BrowseGigsTabProps {
  gigs: Gig[];
  isLoading: boolean;
}

const BrowseGigsTab = ({ gigs, isLoading }: BrowseGigsTabProps) => {
  const router = useRouter();
  const { uid: userUid, userType } = useSelector(
    (state: RootState) => state.user.user
  );

  return (
    <Box sx={{ backgroundColor: theme.whiteBg.WBG1 }}>
      {gigs.length > 0 ? (
        <>
          <Typography variant="title4" sx={{ p: 3 }}>
            Gigs you might like
          </Typography>
          <Grid container>
            {gigs.map((gig, index) => {
              return (
                <Grid key={index} item xs={12} md={12}>
                  <GigCard gigStatusDisplay={true} gig={gig} />
                </Grid>
              );
            })}
          </Grid>
        </>
      ) : (
        !isLoading && (
          <NoDataUI
            Icon={FoodBankOutlinedIcon}
            displayMessage={"No gig available "}
          />
        )
      )}
    </Box>
  );
};

export default BrowseGigsTab;
